__turbopack_context__.v({
  "active": "DashboardNav-module-scss-module__e57Kmq__active",
  "bottomNavbarWrapper": "DashboardNav-module-scss-module__e57Kmq__bottomNavbarWrapper",
  "dropdownMenuItemClassName": "DashboardNav-module-scss-module__e57Kmq__dropdownMenuItemClassName",
  "dropdownToggleClassName": "DashboardNav-module-scss-module__e57Kmq__dropdownToggleClassName",
  "icon": "DashboardNav-module-scss-module__e57Kmq__icon",
  "label": "DashboardNav-module-scss-module__e57Kmq__label",
  "main": "DashboardNav-module-scss-module__e57Kmq__main",
  "menuItem": "DashboardNav-module-scss-module__e57Kmq__menuItem",
  "navMenu": "DashboardNav-module-scss-module__e57Kmq__navMenu",
  "postLoadLory": "DashboardNav-module-scss-module__e57Kmq__postLoadLory",
  "postingIcon": "DashboardNav-module-scss-module__e57Kmq__postingIcon",
  "postingLabel": "DashboardNav-module-scss-module__e57Kmq__postingLabel",
  "postingLabelContainer": "DashboardNav-module-scss-module__e57Kmq__postingLabelContainer",
  "postingMenuDropdownContainer": "DashboardNav-module-scss-module__e57Kmq__postingMenuDropdownContainer",
  "postingMenuItem": "DashboardNav-module-scss-module__e57Kmq__postingMenuItem",
  "postingMenuItemBtn": "DashboardNav-module-scss-module__e57Kmq__postingMenuItemBtn",
  "userProfile": "DashboardNav-module-scss-module__e57Kmq__userProfile",
});
